import React from 'react'
import { localized } from 'decorators'
import { LoadingIndicator } from 'components/loading'
import { useStyles } from './loadingContent.css'

const LoadingContent = (props) => {
  const classes = useStyles()
  return (
    <div className={classes.root}>
      <div><LoadingIndicator /></div>
      <div>{props.text || props.localize('common.loading')}</div>
    </div>
  )
}

export default localized(LoadingContent)
